import React from 'react';

import controllerWithGhost from '../../../main/assets/images/droneSoccer/drone-soccer-controller-ghost.webp';

export const GhostProtocol = () => {
  return (
    <section className="soccer-aircraft-section soccer-ghost-section">
      <div className="soccer-aircraft-image-container soccer-ghost-image-container">
        <img
          src={controllerWithGhost}
          alt="Radio Transmitter Controller with Ghost Protocol"
          className="soccer-aircraft-image soccer-ghost-image"
        />
      </div>
      <div className="soccer-aircraft-text-section soccer-ghost-text-section">
        <div className="soccer-aircraft-titles soccer-ghost-titles">
          <h2 className="soccer-aircraft-subtitle soccer-ghost-subtitle">
            Simple & INTEROPERABle
          </h2>
          <h3 className="soccer-aircraft-title soccer-ghost-title">
            GHOST PROTOCOL
          </h3>{' '}
        </div>
        <p className="soccer-aircraft-description soccer-ghost-description">
          Effortless connection with all ORQA products through the Ghost
          ecosystem ensures flawless{' '}
          <span style={{ whiteSpace: 'nowrap' }}>2.4 GHz</span> connectivity and
          reliable control.
        </p>
      </div>
    </section>
  );
};
